<template>
  <div>
    <div class="flex bg-white">
      <div class="flex-1 flex justify-between py-2 px-4">
        {{ client.name }}
      </div>
      <base-button @click="client.editing = !client.editing">
        <icon-edit />
      </base-button>
    </div>

    <div class="flex bg-white border-t border-gray-200">
      <div class="text-xs font-mono py-2 px-4">
        <icon-link class="text-sm align-middle mb-1 mr-2" />
        <template v-if="targetsPreviewText">
          <span class="italic">Export targets:</span>
          {{ targetsPreviewText }}
        </template>
        <template v-else>
          <span class="italic">No export targets</span>
        </template>
      </div>
    </div>

    <admin-export-client-form
      v-if="client.editing"
      :client="client"
      :targets="targets"
      @saved="client.editing = false"
      class="mb-8"
    />
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';
import AdminExportClientForm from './AdminExportClientForm.vue';

export default {
  components: { AdminExportClientForm },
  props: {
    client: Object,
  },
  setup(props, { root }) {
    const allTargets = computed(
      () => root.$store.state.company.exports.targets
    );
    const targets = computed(() =>
      allTargets.value.filter((t) => t.export_client === props.client.id)
    );
    const targetsPreviewText = computed(
      () =>
        targets.value.length !== 0 &&
        targets.value.map((t) => t.identifier).join(', ')
    );

    return {
      targets,
      targetsPreviewText,
    };
  },
};
</script>
